import React, { useContext } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { useCurrentUser } from '../../../../utils/hooks/useCurrentUser';
import { ResourceType } from '../../../../types/resource';
import AuthorWatchButton from '../../../../Button/AuthorWatchButton';
import DeviationSidebarMosaic from '../../../_partials/DeviationSidebarMosaic';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
import UserLink from '../../../../User/Link/UserLink';
import s from './UserBlock.scss';
var UserBlock = function (_a) {
    var user = _a.user, deviations = _a.deviations, parentDeviation = _a.parentDeviation;
    var isMobile = useContext(MobileContext);
    var updated_sidebar_styles = useFlag('updated_sidebar_styles');
    var headerClassName = updated_sidebar_styles
        ? 'user-header-updated_sidebar_styles'
        : 'user-header';
    var fylt_suggested_users = useFlag('fylt_suggested_users');
    var currentUser = useCurrentUser();
    var showWatchButton = fylt_suggested_users && !isMobile && user.userId !== currentUser.userId;
    return (React.createElement(BiLoggerContextProvider, { value: {
            sectionid: user.userId,
            section_typeid: ResourceType.USER,
        } },
        React.createElement("div", { className: s['root'] },
            React.createElement("div", { className: s[headerClassName] },
                !isMobile && updated_sidebar_styles ? (React.createElement(UserLink, { className: s['user-link-updated_sidebar_styles'], user: user })) : (React.createElement(UserLink, { user: user, className: s['by-author'] })),
                showWatchButton && (React.createElement(AuthorWatchButton, { className: s['watch-button'], author: user }))),
            isMobile ? (React.createElement(DeviationSidebarMosaic, { streamId: "devpage-sidebar-users-".concat(parentDeviation.deviationId, "-").concat(user.userId), className: s['user-grid'], parentDeviation: parentDeviation, deviations: deviations })) : (React.createElement(DeviationSidebarGrid, { streamId: "devpage-sidebar-users-".concat(parentDeviation.deviationId, "-").concat(user.userId), className: s['user-grid'], parentDeviation: parentDeviation, deviations: deviations, maxRows: 1 })))));
};
UserBlock.displayName = 'UserBlock';
export default UserBlock;
//# sourceMappingURL=UserBlock.js.map